var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceChartUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 33,
    viewBox: "0 0 59 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1377 11.2902L0.5 16V31C0.5 32.1046 1.39543 33 2.5 33H56.5C57.6046 33 58.5 32.1046 58.5 31V6.5L49.5428 12.5545C48.4598 13.2866 46.9771 12.7999 46.5386 11.5683L44.4553 5.71634C44.4041 5.57259 44.3366 5.43516 44.2542 5.30675L42.4667 2.52194C41.6962 1.32163 39.9529 1.29053 39.1401 2.46259L35.4795 7.74111C35.3606 7.91264 35.2692 8.10175 35.2088 8.30155L33.7601 13.0889C33.2322 14.8334 30.8364 15.0202 30.0445 13.3786L27.4711 8.04422C27.0424 7.15564 26.0298 6.71239 25.0862 7.00024L20.8492 8.29269C20.4096 8.42679 20.0295 8.70822 19.7731 9.08962L16.622 13.7755C15.8756 14.8854 14.2712 14.9641 13.4198 13.9325L11.6377 11.7731C11.0277 11.034 9.97909 10.8314 9.1377 11.2902Z",
    fill: "url(#paint0_linear_1001_315857)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 16L9.04197 11.3019C9.88689 10.8372 10.9431 11.0416 11.5537 11.7879L13.2878 13.9073C14.1391 14.9478 15.7541 14.8689 16.4998 13.7503L19.6049 9.09268C19.8604 8.70935 20.2405 8.42601 20.6808 8.29052L24.8517 7.00718C25.7988 6.71575 26.8165 7.16185 27.2441 8.05583L29.7672 13.3313C30.556 14.9807 32.9617 14.7943 33.4871 13.0431L34.91 8.30014C34.9696 8.10126 35.0599 7.91288 35.1775 7.74178L38.7875 2.49094C39.5994 1.30996 41.3535 1.34115 42.1229 2.55025L43.8774 5.30729C43.9589 5.43535 44.0255 5.57227 44.076 5.7154L46.1349 11.5489C46.5719 12.7869 48.0629 13.2753 49.1476 12.5357L58 6.5",
    stroke: "#38602B",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1001_315857",
    x1: 29.5,
    y1: -25.5,
    x2: 29.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9FBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD287",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceChartUp);
export default __webpack_public_path__ + "static/media/price-chart-up.56e91f36bbc6a6fdcaab302f1e563fb8.svg";
export { ForwardRef as ReactComponent };